module.exports = __webpack_public_path__ + "img/payment05.ac86fe74.png";